import { SENTRY_EXTRAS_EXCLUDE as d } from "./constants.js";
import { isPlainObject as m, redact as l, findError as p } from "./redact.js";
const b = (t) => ({
  level: "error",
  send: (u, n) => {
    if (!t.getClient())
      return;
    const r = n.messages, s = m(r[0]) ? r[0] : void 0, f = r.find(
      (e) => typeof e == "string"
    ), c = n.bindings.reduce(
      (e, i) => {
        const g = i.context;
        return typeof g == "string" ? g : e;
      },
      void 0
    ), o = {};
    if (s)
      for (const [e, i] of Object.entries(s))
        d.has(e) || (o[e] = l(i));
    const a = p(s, r);
    t.withScope((e) => {
      c && e.setTag("context", c), Object.keys(o).length > 0 && e.setExtras(o), a ? t.captureException(a) : t.captureMessage(
        f ?? "Error logged without a message",
        "error"
      );
    });
  }
});
export {
  b as createBrowserSentryTransmit
};
